<template>
    <b-container>
        <div class="card ">
            <div class="card-header main-card">
                Analítica de guías agrupada
            </div>
            <div class="card-body">
                <div>
                    <div class="d-flex justify-content-between mb-4">
                        <analytics-filter :trigger="triggerSearch" /> 
                    </div>
                    <table  class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col" title="Guía">Guía</th>
                                <th scope="col" title="Núm buses">Número buses</th>
                                <th scope="col" title="1-19">1-19</th>
                                <th scope="col" title="20-39">20-39</th>
                                <th scope="col" title="40-55">40-55</th>
                                <th scope="col" title="55-59">55-59</th>
                                <th scope="col" title="60-73">60-73</th>
                                <th scope="col" title="+74">+74</th>
                                <th scope="col" title="Típo">Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="analyticsGrouped.length == 0">
                                <td colspan="9">
                                    No hay resultados para los datos introducidos
                                </td>
                            </tr>
                            <analytics-grouped-table-row
                                v-else
                                v-for="(entry, idx) in analyticsGrouped"
                                :key="entry.id"
                                :row="entry"
                                :idx="idx"
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
/* eslint-disable */
import AnalyticsGroupedTableRow from './AnalyticsGroupedTableRow.vue'
import AnalyticsFilter from '../Breakdown/AnalyticsGuideFilter.vue'
import { mapGetters } from "vuex";

export default {
    components: {
        AnalyticsGroupedTableRow,
        AnalyticsFilter
    },
    data() {
        return {
            analyticsGrouped: []
        }
    },
    methods: {
        async triggerSearch() {
            const filter = this.guideAnalyticsFilter
            if (filter.day_init != null && filter.day_end != null ) {
                this.analyticsGrouped = await this.$store.dispatch("analytics/retrieveGroupedGuides", filter)
                if ( this.analyticsGrouped.length == 0 ) {
                    this.$notify({
                        group: "foo",
                        title: "No hay resultados",
                        text: "No hay resultados para los parámetros de filtrado",
                        type: "warning",
                    });
                }
            } else {
                this.$notify({
                    group: "foo",
                    title: "Seleccionar el rango de fechas",
                    text: "Es necesario seleccionar como mínimo el rango de fechas de la barra de búsqueda",
                    type: "error",
                });
            }
        }
    },
    computed: {
        ...mapGetters(["guides"]),
        ...mapGetters(["guideAnalyticsFilter"])
    },
}
</script>
